import { render, staticRenderFns } from "./vue-tel-input.vue?vue&type=template&id=640867be&"
import script from "./vue-tel-input.vue?vue&type=script&lang=js&"
export * from "./vue-tel-input.vue?vue&type=script&lang=js&"
import style0 from "../assets/sprite.css?vue&type=style&index=0&lang=css&"
import style1 from "../assets/component.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports